import React, { Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import { ApmRoute } from "@elastic/apm-rum-react";
import { getDefaultDashboardLocation } from "../../../config/utils";

const PublicRoute = ({ component: Component, ...rest }) => {
    let hasLandingPage = localStorage.getItem("hasLandingPage") === "true" ? true : false;

    return (
        <ApmRoute
            {...rest}
            render={props =>
                localStorage.getItem("userId") ? (
                    <Redirect to={hasLandingPage ? "/home" : getDefaultDashboardLocation()} />
                ) : localStorage.getItem("crRequestorMail") ? (
                    <Redirect to={{ pathname: "/capital-request/PJ00293" }} />
                ) : (
                    <Suspense fallback={<></>}>
                        {" "}
                        <Component {...props} />
                    </Suspense>
                )
            }
        />
    );
};
export default PublicRoute;
